// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { BootstrapBadge, BootstrapIcon } from '../../../../dsl/front';
/**
 * Tile labels component
 * Displays article labels including premium badge and custom labels
 */
let TileLabels = class TileLabels extends Vue {
    /**
     * Determines if labels should be visible
     */
    get shouldShow() {
        return (this.showArticleTags && this.hasLabels) || this.article.paywall || this.article.sponsored;
    }
    /**
     * Gets article labels if available
     */
    get labels() {
        if (!this.hasLabels) {
            return [];
        }
        return this.article.properties.labels;
    }
    /**
     * Determines whether there are any labels to be rendered
     */
    get hasLabels() {
        return (this.article.properties.labels !== null &&
            Array.isArray(this.article.properties.labels) &&
            this.article.properties.labels.length > 0);
    }
};
__decorate([
    Prop({
        type: Object,
        required: true
    })
], TileLabels.prototype, "article", void 0);
__decorate([
    Prop({
        type: Boolean,
        required: true
    })
], TileLabels.prototype, "showArticleTags", void 0);
TileLabels = __decorate([
    Component({
        name: 'TileLabels',
        components: {
            BootstrapBadge,
            BootstrapIcon
        },
        template: `
    <ul v-if="shouldShow" class="tile__labels list-inline">
      <li v-if="article.paywall" class="tile__label">
        <BootstrapBadge>
          <BootstrapIcon name="premium" size="small" />
          premium
        </BootstrapBadge>
      </li>
      <template v-if="showArticleTags">
        <li v-for="(label, index) in labels" :key="label.name + index"
            class="tile__label">
          <BootstrapBadge :theme="label.color">
            {{ label.name }}
          </BootstrapBadge>
        </li>
      </template>
    </ul>
  `
    })
], TileLabels);
export { TileLabels };
